module.exports = __webpack_public_path__ + "img/44.6a910c61.jpg";